import {
  motion,
  useReducedMotion,
} from "framer-motion";

/*
  ============================================================
  PHOTOGRAPHY PREMIUM
  HANDWRITTEN EYEBROW
  ============================================================

  Esimerkiksi:

  "Kuvaukset · Palvelut"

  muuttuu visuaalisesti:

  Kuvaukset        <- käsin kirjoittuva kaunokirjoitus
  PALVELUT         <- pieni editorial descriptor

  Komponentti käyttää järjestelmän script-fontteja.
  Myöhemmin voidaan vaihtaa oma lisensoitu signature-fontti
  muuttamatta animaatiota tai sivukomponentteja.
*/

export default function HandwrittenEyebrow({
  label = "",
}) {
  const reduceMotion =
    useReducedMotion();

  const parts =
    String(label || "")
      .split("·")
      .map(
        (part) =>
          part.trim()
      )
      .filter(Boolean);

  const handwritten =
    parts[0] || "";

  const descriptor =
    parts.slice(1).join(" · ");

  const characters =
    Array.from(handwritten);

  const writingDuration =
    Math.max(
      0.7,
      characters.length * 0.065
    );

  return (
    <div
      className="
        mb-8
        min-w-0
      "
    >
      <span className="sr-only">
        {label}
      </span>

      <div
        className="
          handwritten-eyebrow
          min-w-0
          text-text
        "
        aria-hidden="true"
      >
        {characters.map(
          (
            character,
            index
          ) => (
            <motion.span
              key={`${character}-${index}`}
              className="
                handwritten-eyebrow__character
                inline-block
              "
              initial={
                reduceMotion
                  ? false
                  : {
                      opacity: 0,
                      y: 5,
                      rotate: -2.5,
                    }
              }
              animate={{
                opacity: 1,
                y: 0,
                rotate: 0,
              }}
              transition={{
                duration:
                  reduceMotion
                    ? 0
                    : 0.28,

                delay:
                  reduceMotion
                    ? 0
                    : 0.1 +
                      index *
                        0.065,

                ease: [
                  0.22,
                  1,
                  0.36,
                  1,
                ],
              }}
            >
              {character === " "
                ? "\u00A0"
                : character}
            </motion.span>
          )
        )}
      </div>

      <motion.svg
        viewBox="0 0 120 12"
        className="
          mt-1
          block
          h-3
          w-24
          overflow-visible
          text-text
        "
        aria-hidden="true"
        initial={
          reduceMotion
            ? false
            : {
                opacity: 0,
              }
        }
        animate={{
          opacity: 0.42,
        }}
        transition={{
          duration: 0.3,
          delay:
            reduceMotion
              ? 0
              : writingDuration +
                0.15,
        }}
      >
        <motion.path
          d="M2 8 C 26 5, 56 10, 118 4"
          fill="none"
          stroke="currentColor"
          strokeWidth="0.85"
          strokeLinecap="round"
          pathLength="1"
          initial={
            reduceMotion
              ? false
              : {
                  pathLength: 0,
                }
          }
          animate={{
            pathLength: 1,
          }}
          transition={{
            duration:
              reduceMotion
                ? 0
                : 0.55,

            delay:
              reduceMotion
                ? 0
                : writingDuration +
                  0.08,

            ease: [
              0.22,
              1,
              0.36,
              1,
            ],
          }}
        />
      </motion.svg>

      {descriptor && (
        <motion.p
          className="
            mb-0
            mt-2
            text-[9px]
            font-medium
            uppercase
            tracking-[0.3em]
            text-muted

            sm:text-[10px]
          "
          initial={
            reduceMotion
              ? false
              : {
                  opacity: 0,
                  y: 5,
                }
          }
          animate={{
            opacity: 1,
            y: 0,
          }}
          transition={{
            duration:
              reduceMotion
                ? 0
                : 0.5,

            delay:
              reduceMotion
                ? 0
                : writingDuration +
                  0.42,
          }}
          aria-hidden="true"
        >
          {descriptor}
        </motion.p>
      )}
    </div>
  );
}